import {
  GridView as UserGridIcon,
  Login as LoginIcon,
  PersonAdd as AddUserIcon,
} from "@mui/icons-material";
import DashboardIcon from "./Dashboard";
import SessionsIcon from "./Sessions";
import UserManagementIcon from "./UserManagement";
import UserProfileIcon from "./UserProfile";
import FormsIcon from "./FormsIcon";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  LoginIcon,
  AddUserIcon,
  SessionsIcon,
  UserGridIcon,
  DashboardIcon,
  UserProfileIcon,
  UserManagementIcon,
  FormsIcon,
};
